import { PropsWithChildren } from 'react';
import { dialogOverlay } from '../../../../../styled-system/recipes';

export const DialogOverlay = ({ children }: PropsWithChildren) => {
  return <div className={dialogOverlay()}>{children}</div>;
};
